<template>
  <div>
    <el-row
        :gutter="50"
        class="profile-row">
      <el-col :span="8">
        <div class="profile-label">
          Timezone
        </div>
      </el-col>
      <el-col :span="16">
        <TimeZoneSelector />
      </el-col>
    </el-row>

    <el-row
        :gutter="50"
        class="profile-row">
      <el-col :span="8">
        <div class="profile-label">
          Language
        </div>
      </el-col>
      <el-col :span="16">
        <LanguageSelector />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import TimeZoneSelector from "./TimeZoneSelector";
import LanguageSelector from "./LanguageSelector";

export default {
  name: "TimeZoneAndLanguageSelectorRow",
  components: { LanguageSelector, TimeZoneSelector },
};
</script>

<style scoped></style>
